(() => {
  const init = root => {
    if (root.dataset.initialized === 'true') return;
    const form = root.querySelector('[data-hair-form]');
    const steps = [...root.querySelectorAll('[data-stage]')];
    if (!form || !steps.length) return;
    root.dataset.initialized = 'true';
    const config = JSON.parse(root.querySelector('[data-hair-config]').textContent);
    const links = [...root.querySelectorAll('[data-step-jump]')];
    const next = form.querySelector('[data-next]');
    const back = form.querySelector('[data-back]');
    const submit = form.querySelector('[data-submit]');
    let active = 0;
    let visited = 0;
    form.noValidate = true;
    const answer = group => group.querySelector('[type="radio"]')
      ? group.querySelector('[type="radio"]:checked')?.value || ''
      : group.querySelector('[data-answer]')?.value.trim() || '';
    const error = (group, message) => {
      const notice = group.querySelector('[data-error]');
      notice.textContent = message;
      notice.hidden = !message;
      group.classList.toggle('has-error', Boolean(message));
      group.querySelectorAll('[data-answer]').forEach(input => input.setAttribute('aria-invalid', String(Boolean(message))));
    };
    const validate = index => {
      let invalid = null;
      for (const group of steps[index].querySelectorAll('[data-question]')) {
        let message = answer(group) ? '' : config.required;
        const email = group.querySelector('[type="email"]');
        if (email && email.value && !email.checkValidity()) message = config.email;
        error(group, message);
        if (message && !invalid) invalid = group;
      }
      return invalid;
    };
    const go = (index, focus = true) => {
      active = index;
      steps.forEach((stage, i) => { stage.hidden = i !== index; });
      links.forEach((link, i) => {
        link.disabled = i > visited;
        link.classList.toggle('is-complete', i < index);
        if (i === index) link.setAttribute('aria-current', 'step'); else link.removeAttribute('aria-current');
      });
      const percent = Math.round((index + 1) / steps.length * 100);
      root.querySelector('[data-progress-copy]').textContent = config.step.replace('{current}', index + 1).replace('{total}', steps.length);
      root.querySelector('[data-progress-value]').textContent = percent + '%';
      root.querySelector('[data-progress-fill]').style.width = percent + '%';
      root.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', String(percent));
      root.querySelector('[role="progressbar"]').setAttribute('aria-valuetext', `${index + 1} / ${steps.length}`);
      back.hidden = index === 0;
      next.hidden = index === steps.length - 1;
      submit.hidden = index !== steps.length - 1;
      form.querySelector('[data-first-tip]').hidden = index !== 0;
      if (focus) {
        root.querySelector('[data-survey-card]').scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
        steps[index].querySelector('h2').focus({preventScroll: true});
      }
    };
    const focusInvalid = group => {
      group.scrollIntoView({behavior: 'auto', block: 'center'});
      group.querySelector('[data-answer]').focus({preventScroll: true});
    };
    const serialize = () => {
      const lines = [config.subject, config.surveyId, ''];
      for (const group of form.querySelectorAll('[data-question]')) {
        if (group.dataset.question === 'EMAIL') continue;
        lines.push(group.dataset.question + '. ' + group.querySelector('.pfs__question-title').textContent.trim(), answer(group), '');
      }
      lines.push(config.contactPermission + ': ' + (form.querySelector('[data-contact-permission]').checked ? config.yes : config.no));
      return lines.join('\n');
    };
    next.addEventListener('click', () => {
      const invalid = validate(active);
      if (invalid) return focusInvalid(invalid);
      visited = Math.max(visited, active + 1);
      go(active + 1);
    });
    back.addEventListener('click', () => go(active - 1));
    links.forEach(link => link.addEventListener('click', () => go(Number(link.dataset.stepJump))));
    for (const event of ['input', 'change']) form.addEventListener(event, event => {
      const group = event.target.closest('[data-question]');
      if (group) error(group, '');
    });
    form.addEventListener('submit', event => {
      for (let index = 0; index < steps.length; index++) {
        const invalid = validate(index);
        if (invalid) { event.preventDefault(); go(index); focusInvalid(invalid); return; }
      }
      const body = serialize();
      form.querySelector('[data-feedback-body]').value = body;
      if (root.dataset.preview === 'true') {
        event.preventDefault();
        const notice = form.querySelector('[data-preview-result]');
        notice.textContent = config.previewMessage;
        notice.hidden = false;
        root.dispatchEvent(new CustomEvent('palm:hair-survey-preview', {detail: {body}}));
      }
    });
    form.addEventListener('keydown', event => {
      if (event.key === 'Enter' && event.target.matches('input[type="email"]') && !next.hidden) { event.preventDefault(); next.click(); }
    });
    root.classList.add('is-ready');
    go(0, false);
  };
  const mount = scope => scope.querySelectorAll('[data-palm-hair-survey]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document)); else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
